let url = location.protocol + '//' + location.hostname + '/';

if (location.hostname === "localhost" || location.hostname === "127.0.0.1") url = 'http://local.kotofey.store/';

const config = {
    restGeo: url + 'api/geo/',
    restGeoCurrent: url + 'api/geo/current/',
    restCompare: url + 'api/compare/',
    restTariffs: url + 'api/delivery/tariffs/',
    restCompareMixed: url + 'api/compare/mixed/',
    restFavorite: url + 'api/favorite/',
    restOrder: url + 'api/order/',
    restOrderItems: url + 'api/order/items/',
    restOrderCustomer: url + 'api/order/customer/',
    restOrderMailHistory: url + 'api/order/order-mail-history/',
    restFastOrder: url + 'api/order/fast/',
    restOrderStatus: url + 'api/order/status/',
    restOrderRepeat: url + 'api/order/repeat/',
    restBasket: url + 'api/basket/',
    restBasketVirtual: url + 'api/basket/virtual/',
    restDelivery: url + 'api/delivery/',
    restDeliveryService: url + 'api/delivery/service/',
    restDeliveryCalculate: url + 'api/delivery/calculate/',
    restDeliveryCleanAddress: url + 'api/delivery/clean-address/',
    restPayment: url + 'api/payment/',
    restVendor: url + 'api/vendors/',
    restDate: url + 'api/order/date/',
    restTime: url + 'api/order/time/',
    ajaxActionGetMiniCartAmount: url + 'get-mini-cart-amount/',
    ajaxActionGetMiniCartCount: url + 'get-mini-cart-count/',
    restCatalog: url + 'api/catalog/',
    restCatalogRecommendation: url + 'api/catalog/recommendation/',
    restBonus: url + 'api/bonus/',
    restPromocode: url + 'api/promocode/',
    restUser: url + 'api/user/',
    // sberbank payments
    restAcquiring: url + 'api/acquiring/',
    restAcquiringOrder: url + 'api/acquiring/order/',
    // pets
    restAnimal: url + 'api/pets/animal/',
    restBreeds: url + 'api/pets/breed/',
    restPetCalculator: url + 'api/pets/calculate/',
    //ozon
    restOzon: url + 'api/marketplace/ozon/',
    // logistic
    restMapLogistic: url + 'api/logistic/map/',
};


export default config;